import { Injectable, inject } from '@angular/core';
import { ASSET_REPOSITORY } from '../ports';
import { ExplorerStore } from '../state/explorer.store';

@Injectable()
export class LoadAssetChildrenUseCase {
  private readonly repository = inject(ASSET_REPOSITORY);
  private readonly store = inject(ExplorerStore);
  private readonly _inFlight = new Set<string>();

  async execute(parentId: string): Promise<void> {
    if (this.store.isChildrenLoaded(parentId) || this._inFlight.has(parentId))
      return;

    this._inFlight.add(parentId);
    try {
      const children = await this.repository.loadChildren(parentId);
      this.store.mergeChildren(parentId, children);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : `Failed to load children for ${parentId}`;
      this.store.setNodeError(message);
    } finally {
      this._inFlight.delete(parentId);
    }
  }
}
